import { SessionTableRow } from '@/types/analytics';
import { dismissOnContextMenu } from '@/util/menu';
import { Check } from '@mui/icons-material';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FC } from 'react';

export type SessionFlowContextMenu = { mouseX: number; mouseY: number; line: SessionTableRow; isMarked: boolean };

export type SessionFlowHighlights = {
  block: string;
  blocktype: string;
  task: string;
  subroutine: string;
  channel: string;
};

export type SessionFlowMenuProps = {
  contextMenu: SessionFlowContextMenu | null;
  highlights: SessionFlowHighlights;
  onSubmit: (type: string, id: string) => void;
  onClose: () => void;
};

const SessionFlowMenu: FC<SessionFlowMenuProps> = ({ contextMenu, highlights, onSubmit, onClose }) => {
  if (!contextMenu?.line) return;

  const line = contextMenu.line;

  const highlightItems = [
    { type: 'block', label: 'Highlight Block', value: line.block_id, active: highlights.block },
    { type: 'blocktype', label: 'Highlight Block Type', value: line.block_type, active: highlights.blocktype },
    { type: 'task', label: 'Highlight Task', value: line.task, active: highlights.task },
    { type: 'subroutine', label: 'Highlight Subroutine', value: line.sub_name.trim(), active: highlights.subroutine },
    { type: 'channel', label: 'Highlight Channel', value: line.channel, active: highlights.channel }
  ].map((item) => ({ ...item, checked: !!item.value && item.active === item.value }));

  const highlightExists = highlightItems.some((item) => item.checked);

  return (
    <Menu
      open={contextMenu !== null}
      onClose={onClose}
      anchorReference='anchorPosition'
      anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
      slotProps={dismissOnContextMenu(onClose)}
    >
      <MenuItem
        onClick={() => {
          onSubmit('marker', contextMenu.line.row.toString());
          onClose();
        }}
      >
        {!contextMenu.isMarked ? 'Add' : 'Remove'} Marker
      </MenuItem>
      <Divider />
      {highlightItems.map((item) => (
        <MenuItem
          key={item.type}
          selected={item.checked}
          onClick={() => {
            onSubmit(item.type, item.value);
            onClose();
          }}
        >
          <ListItemIcon>{item.checked && <Check fontSize='small' />}</ListItemIcon>
          <ListItemText>{item.label}</ListItemText>
        </MenuItem>
      ))}
      <MenuItem
        disabled={!highlightExists}
        onClick={() => {
          onSubmit('', contextMenu.line.channel);
          onClose();
        }}
        sx={{ my: 1 }}
      >
        Remove Highlight
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={() => {
          onSubmit('navigate', contextMenu.line.block_id);
          onClose();
        }}
      >
        Navigate to Block {contextMenu.line.block_id}
      </MenuItem>
    </Menu>
  );
};

export default SessionFlowMenu;
